// extracted by mini-css-extract-plugin
module.exports = {"cookiesContainer":"CookiesConsent_cookiesContainer__ffAde","textContainer":"CookiesConsent_textContainer__3QZCm","buttonsSection":"CookiesConsent_buttonsSection__qN7HG"};